import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useUser } from "../contexts/UserContext";
import Modal from 'react-bootstrap/Modal';
import { use, useRef, useState } from "react";
import { appInfo } from "../config/appInfo.const";
import Login from "./Login";
import Register from "./Register";
import { useEffect } from "react";
import { _get } from "../services/apiClient";
import { logout as authLogout } from "../services/authService";
import { apiUrls } from "../config/apiUrls.const";
import { getSecureItem, getStoredInfo } from "../utils/LocalStorageManager";
import Location from "./Location";
import eventBus from "../utils/EventBus";
import { useClient } from "../contexts/ClientContext";

export default function Header() {
  const { client } = useClient();
  const location = useLocation();
  const isClientPage = location.pathname.startsWith("/webpage/");

  const defaultLogo = "pl-logo.jpg";

  // Example: You can change this later based on API
  const { biz_code } = useParams();
  const titleToShow = isClientPage ? client?.title : appInfo.appName;
  const logoToShow = isClientPage ? client?.logo : defaultLogo;

  // useEffect(() => {
  //   if(isClientPage){
  //     console.log(biz_code)
  //   }else{
  //     console.log("Not a client page");
  //   }
  // }, [isClientPage]);

  const [activeLocation, setActiveLocation] = useState<any>(getStoredInfo('location'));
  const [locationTitle, setLocationTitle] = useState<string>('Location');
  const [spaItems, setSpaItems] = useState<any[]>([]);
  const [parlorItems, setParlorItems] = useState<any[]>([]);
  const [salonItems, setSalonItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const [spaMenuActive, setSpaMenuActive] = useState(false);
  const [parlorMenuActive, setParlorMenuActive] = useState(false);
  const [salonMenuActive, setSalonMenuActive] = useState(false);

  // refs for mega menus
  const spaRef = useRef<HTMLDivElement>(null);
  const parlorRef = useRef<HTMLDivElement>(null);
  const salonRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const toggleSpaMenu = () => {
    setParlorMenuActive(false);
    setSalonMenuActive(false);
    setSpaMenuActive((prev) => !prev);
  };

  const toggleParlorMenu = () => {
    setSpaMenuActive(false);
    setSalonMenuActive(false);
    setParlorMenuActive((prev) => !prev);
  };

  const toggleSalonMenu = () => {
    setSpaMenuActive(false);
    setParlorMenuActive(false);
    setSalonMenuActive((prev) => !prev);
  };

  useEffect(() => {
    const stored = getStoredInfo('location');
    if (!stored) {
      setShowLocation(true);
    } else {
      setActiveLocation(stored);
      setLocationTitle(
        stored?.thana?.name_en ||
        stored?.district?.name_en ||
        stored?.division?.name_en ||
        'Location'
      );
      fetchData(stored);
    }
  }, []);

  function setLocationInfo() {
    const stored = getStoredInfo('location');
    if (stored) {
      setActiveLocation(stored);
      setLocationTitle(
        stored?.thana?.name_en ||
        stored?.district?.name_en ||
        stored?.division?.name_en ||
        'Location'
      );
    }
  }

  function fetchData(activeLocation:any){
    // play with data now
    eventBus.emit("LOCATION_UPDATED", activeLocation);
  }

  // close on outside click
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const target = event.target as HTMLElement;

      // ✅ If the click is on a nav-link, don't run the outside-close logic
      if (target.closest(".nav-link")) {
        return;
      }

      if (
        !spaRef.current?.contains(target) &&
        !parlorRef.current?.contains(target) &&
        !salonRef.current?.contains(target)
      ) {
        setSpaMenuActive(false);
        setParlorMenuActive(false);
        setSalonMenuActive(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const fetchCategorizedItems = async () => {
      setLoading(true);
      try {
        const data = await _get(apiUrls.categorization).then(res => res.data);
        setSpaItems(data?.data?.spa);
        setParlorItems(data?.data?.parlor);
        setSalonItems(data?.data?.salon);
      } catch (err) {
        setError("Failed to fetch categorized items");
      } finally {
        setLoading(false);
      }
    };

    fetchCategorizedItems();
  }, []);

  const { user, logout } = useUser();
  const isAuthenticated = !!getSecureItem("access_token") && !!user;
  const businesses = getSecureItem("businesses");

  const handleLogout = async () => {
    await authLogout();
  };

  const [showLocation, setShowLocation] = useState(false);
  const handleCloseLocation = (title?: any) => {
    if (title && typeof title === 'string') {
      setLocationTitle(title);
    }
    setShowLocation(false);
    fetchData(activeLocation);
  };
  const handleShowLocation = () => setShowLocation(true);

  const [showLogin, setShowLogin] = useState(false);
  const handleCloseLogin = () => setShowLogin(false);
  const handleShowLogin = () => setShowLogin(true);

  const [showRegister, setShowRegister] = useState(false);
  const handleCloseRegister = () => setShowRegister(false);

  function openRegisterModal() {
    setShowLogin(false)
    setShowRegister(true);
  }

  function openLoginModal() {
    setShowRegister(false)
    setShowLogin(true);
  }

  function goToRegisterPage() {
    setShowRegister(false)
    setShowLogin(false);
    navigate('/register');
  }

  const handleBusinessSelect = (bizCode: string) => {
    const token = getSecureItem("access_token");
    window.open(`${appInfo.dashboardUrl}?biz_code=${bizCode}&token=${token}`, "_blank");
  };

  const handleMenuSelect = (bizCode: string) => {
    navigate(`/listing?service_group=parlor&category_id=9&subcategory_id=38&division_id=1&district_id=1&thana_id=9`);
  };

  // Helper to handle navigation with current location
  const handleMenuClick = (group: string, catId?: number, subCatId?: number) => {
    const location = getStoredInfo('location');
    
    const params = new URLSearchParams({
      service_group: group,
      division_id: location?.division?.id || "",
      district_id: location?.district?.id || "",
      thana_id: location?.thana?.id || "",
    });

    if (catId) params.append("category_id", catId.toString());
    if (subCatId) params.append("subcategory_id", subCatId.toString());

    // Close the menu (optional, depending on your state logic)
    setSpaMenuActive(false); 
    setParlorMenuActive(false);
    setSalonMenuActive(false);

    navigate(`/listing?${params.toString()}`);
  };

  return (
    <>
      <header id="header" className="header d-flex align-items-center fixed-top">
        <div className="container-fluid container-xl position-relative d-flex align-items-center">
          <a href="/" className="logo d-flex align-items-center me-auto">
            <img src={logoToShow} alt="" />
            <h1 className="sitename">{titleToShow}</h1>
          </a>

          <a className="btn-getstarted" onClick={handleShowLocation}>
            <i className="bi bi-geo-alt-fill"></i>
            <br />
            <small>{ locationTitle }</small>
          </a>
        </div>
      </header>

      <div className="topbar">
        <div className="container-fluid container-xl d-flex align-items-center justify-content-between">
          <div className="topbar-left">
            <span className="topbar-nav">
              <Link className="nav-link" to="/">
                <i className="bi bi-house"></i>
                <span className="nav-title">Home</span>
              </Link>
            </span>
            <span className="topbar-nav">
              <span className="nav-link pointer" onClick={toggleSpaMenu}>
                💆
                <span className="nav-title">Spa</span>
              </span>
            </span>
            <span className="topbar-nav">
              <span className="nav-link pointer" onClick={toggleParlorMenu}>
                👰
                <span className="nav-title">Parlor</span>
              </span>
            </span>
            <span className="topbar-nav">
              <span className="nav-link pointer" onClick={toggleSalonMenu}>
                🧔
                <span className="nav-title">Salon</span>
              </span>
            </span>
            {/* <span className="topbar-nav">
              <Link className="nav-link" to="/terms-conditions">
                <i className="bi bi-list-check"></i>
                <span className="nav-title">Terms & Conditions</span>
              </Link>
            </span> */}
            <span className="topbar-nav">
              <Link className="nav-link" to="/faq">
                <i className="bi bi-question-circle"></i>
                <span className="nav-title">FAQ</span>
              </Link>
            </span>
            {/* <span className="topbar-nav">
              <Link className="nav-link" to="/about">
                <i className="bi bi-info-circle"></i>
                <span className="nav-title">About</span>
              </Link>
            </span> */}
          </div>

          <div className="topbar-right">
            {isAuthenticated ? (
              <Dropdown>
                <Dropdown.Toggle
                  as="span"
                  id="custom-toggle"
                  className={"profile-menu-toggle pointer d-inline-flex align-items-center gap-2" + (user?.avatar_url ? " mt-2" : "")}
                >
                  {user?.avatar_url ? (
                    <img
                      src={user.avatar_url}
                      alt={user?.name || "User"}
                      className="rounded-circle profile-avatar-img"
                      style={{
                        width: "24px",
                        height: "24px",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <i className="bi bi-person-circle"></i>
                  )}
                  
                  {user?.name || "User"}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item as={Link} to="/profile">
                    <i className="bi bi-person-badge"></i> My Profile
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/settings">
                    <i className="bi bi-gear"></i> Settings
                  </Dropdown.Item>
                  <Dropdown.Item onClick={handleLogout}>
                    <i className="bi bi-box-arrow-right"></i> Logout
                  </Dropdown.Item>
                  {Array.isArray(businesses) && businesses.length > 0 && (
                    <>
                      <hr />
                      {businesses.map((business, b) => (
                        <Dropdown.Item key={b} onClick={() => handleBusinessSelect(business?.biz_code)}>
                          <i className="bi bi-speedometer2"></i> {business?.name}
                        </Dropdown.Item>
                      ))}
                    </>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            ) : (
              <div className="topbar-link pointer" onClick={handleShowLogin}>
                <i className="bi bi-box-arrow-in-right"></i> Login
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Spa Menu */}
      <div ref={spaRef} className={`container mega-menu ${spaMenuActive ? "active" : ""}`}>
        <div className="card menu-card">
          <div className="card-body">
            <div className="row">
              {spaItems.map((category: any, idc: number) => (
                <div className="col-lg-3 col-md-4 col-sm-6 mb-3" key={idc}>
                  {/* Category Link */}
                  <span 
                    className="mega-menu-category-link pointer" 
                    onClick={() => handleMenuClick("spa", category.id)}
                  >
                    {category.name_en}
                  </span>
                  <hr className="mt-0 mb-1" />
                  
                  {/* Subcategory Links */}
                  {category.subcategories?.map((subcategory: any, id: number) => (
                    <span 
                      className="mega-menu-link pointer" 
                      key={id}
                      onClick={() => handleMenuClick("spa", category.id, subcategory.id)}
                    >
                      {subcategory.name_en}
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Parlor Menu */}
      <div ref={parlorRef} className={`container mega-menu ${parlorMenuActive ? "active" : ""}`}>
        <div className="card menu-card">
          <div className="card-body">
            <div className="row">
              {parlorItems.map((category: any, idc: number) => (
                <div className="col-lg-3 col-md-4 col-sm-6 mb-3" key={idc}>
                  {/* Category Link */}
                  <span 
                    className="mega-menu-category-link pointer" 
                    onClick={() => handleMenuClick("parlor", category.id)}
                  >
                    {category.name_en}
                  </span>
                  <hr className="mt-0 mb-1" />
                  
                  {/* Subcategory Links */}
                  {category.subcategories?.map((subcategory: any, id: number) => (
                    <span 
                      className="mega-menu-link pointer" 
                      key={id}
                      onClick={() => handleMenuClick("parlor", category.id, subcategory.id)}
                    >
                      {subcategory.name_en}
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Salon Menu */}
      <div ref={salonRef} className={`container mega-menu ${salonMenuActive ? "active" : ""}`}>
        <div className="card menu-card">
          <div className="card-body">
            <div className="row">
              {salonItems.map((category: any, idc: number) => (
                <div className="col-lg-3 col-md-4 col-sm-6 mb-3" key={idc}>
                  {/* Category Link */}
                  <span 
                    className="mega-menu-category-link pointer" 
                    onClick={() => handleMenuClick("salon", category.id)}
                  >
                    {category.name_en}
                  </span>
                  <hr className="mt-0 mb-1" />
                  
                  {/* Subcategory Links */}
                  {category.subcategories?.map((subcategory: any, id: number) => (
                    <span 
                      className="mega-menu-link pointer" 
                      key={id}
                      onClick={() => handleMenuClick("salon", category.id, subcategory.id)}
                    >
                      {subcategory.name_en}
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* location modal */}
      <Modal
        show={showLocation}
        onHide={handleCloseLocation}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Body className="p-5 pt-3">
          <h2 className="text-center">Location</h2>
          <button className="btn btn-sm btn-outline-secondary pull-right modal-closer" onClick={() => handleCloseLocation()}>X</button>
          <Location
            onSuccess={(title:string) => {
              setLocationInfo();
              if (title) setLocationTitle(title);  // update title if provided
              handleCloseLocation(); 
            }}
           />
        </Modal.Body>
      </Modal>

      {/* login modal */}
      <Modal
        show={showLogin}
        onHide={handleCloseLogin}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body className="p-5">
          <h2 className="text-center">Login</h2>
          <button className="btn btn-sm btn-outline-secondary pull-right modal-closer" onClick={handleCloseLogin}>X</button>
          <Login />
        </Modal.Body>
        <Modal.Footer>
          <div className="text-center mt-3">
            <p>
              Don’t have an account?
              {/* <button className="btn btn-md btn-link" onClick={openRegisterModal}>Register Here</button> */}
              <button className="btn btn-md btn-outline-primary ms-2" onClick={goToRegisterPage}>Register Here</button>

            </p>
          </div>
        </Modal.Footer>
      </Modal>

      {/* register modal */}
      <Modal
        show={showRegister}
        onHide={handleCloseRegister}
        backdrop="static"
        keyboard={false}
        // size="lg"
        centered
      >
        <Modal.Body className="p-5">
          <h2 className="text-center">Register</h2>
          <button className="btn btn-sm btn-outline-secondary pull-right modal-closer" onClick={handleCloseRegister}>X</button>
          <Register />
        </Modal.Body>
        <Modal.Footer>
          <div className="text-center mt-3">
            <p>
              Already have an account?<button className="btn btn-md btn-link" onClick={openLoginModal}>Login Here</button>
            </p>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}